import React from "react";
import PageTemplate from "./PageTemplate";
import CSVDownloadButton from "@/components/atoms/CSVDownloadButton";
import BackButton from "@/components/atoms/BackButton";
import ReportConfig from "@/components/molecules/ReportConfig";

function GCPReportsTemplate({
  children,
  title,
  loading = false,
  error = null,
  onRetry = null,
  filtersComponent = null,
  hasActiveFilters = false,
  filteredCount = 0,
  totalCount = 0,
  onClearFilters = null,
  dashboardComponent = null,
  onDownloadCSV = null,
  showBackButton = true,
  filterType,
  filters,
  onFilterChange,
  hideFilters = false,
  hideDownload = false,
}) {
  const renderTitle = () => (
    showBackButton ? (
      <div className="flex items-center space-x-4">
        <BackButton to="/gcp/reports" />
        <span>{title}</span>
      </div>
    ) : title
  );

  const renderHeaderActions = () => (
    !hideDownload && onDownloadCSV && totalCount > 0 ? (
      <CSVDownloadButton onDownload={onDownloadCSV} />
    ) : null
  );

  const renderLoadingState = () => (
    <div className="flex flex-col items-center justify-center py-12">
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
      <p className="text-center text-gray-600 mt-4 text-lg">
        Loading report data...
      </p>
    </div>
  );

  const renderErrorState = () => (
    <div className="bg-red-50 border border-red-200 rounded-lg p-6 mb-6">
      <div className="flex">
        <div className="flex-shrink-0">
          <svg
            className="h-5 w-5 text-red-400"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fillRule="evenodd"
              d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
              clipRule="evenodd"
            />
          </svg>
        </div>
        <div className="ml-3">
          <h3 className="text-sm font-medium text-red-800">
            Error loading data
          </h3>
          <div className="mt-2 text-sm text-red-700">
            <p>{error}</p>
          </div>
          {onRetry && (
            <div className="mt-4">
              <button
                onClick={onRetry}
                className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-red-700 bg-red-100 hover:bg-red-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
              >
                Try Again
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );

  const renderContent = () => (
    <>
      {dashboardComponent}

      {!hideFilters && (filtersComponent || (filterType && (
        <ReportConfig
          filters={filters}
          onFilterChange={onFilterChange}
          filterType={filterType}
          hasActiveFilters={hasActiveFilters}
          filteredCount={filteredCount}
          totalCount={totalCount}
          onClearFilters={onClearFilters}
          onDownloadCSV={onDownloadCSV}
        />
      )))}
      
      {children}
    </>
  );

  return (
    <PageTemplate
      title={renderTitle()}
      containerClassName="space-y-6"
      headerActions={renderHeaderActions()}
    >
      {loading && renderLoadingState()}
      {error && renderErrorState()}
      {!loading && !error && renderContent()}
    </PageTemplate>
  );
}

export default GCPReportsTemplate;